const theme = {
  colors: {
    primary: "#0070f3",
  },
  main: "#CEE5D0",
};

export default theme;
